/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useMemo, useState } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { MasterFilterCompactPicker } from '../../../../shared/filters/MasterFilterCompactPicker'
import { MasterFilterSheetModal } from '../../../../shared/filters/MasterFilterSheetModal'
import type { MasterFilterOption } from '../../../../shared/filters/MasterFilterSheetModal';
import { ticketColors } from '../../../../shared/theme/ticketColors'
import { spacing } from '../../../../shared/theme/spacing'
import { typography } from '../../../../shared/theme/typography';
import type { RolePreset } from './EmployeeRolePresets';

type Props = {
  presets: RolePreset[];
  onApply: (preset: RolePreset) => void;
  disabled?: boolean;
};

export function RolePresetPicker({ presets, onApply, disabled }: Props) {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string>(presets[0]?.id ?? 'cashier');

  const options: MasterFilterOption[] = useMemo(
    () => presets.map((p) => ({ id: p.id, name: p.label })),
    [presets]
  );

  const selected = presets.find((p) => p.id === selectedId) ?? presets[0];

  if (!selected) return null;

  return (
    <View style={styles.wrap} testID="perfil.team.detail.preset-picker">
      <MasterFilterCompactPicker
        caption="Aplicar rol"
        value={selected.label}
        active
        onPress={() => !disabled && setSheetOpen(true)}
      />
      <Text style={styles.description}>Reemplaza los permisos actuales de esta sucursal.</Text>
      <TouchableOpacity
        style={[styles.applyBtn, disabled && styles.applyBtnDisabled]}
        onPress={() => onApply(selected)}
        disabled={disabled}
        accessibilityRole="button"
        accessibilityLabel={`Usar rol ${selected.label}`}
        testID="perfil.team.detail.preset-apply"
      >
        <Text style={styles.applyBtnText}>Usar este rol</Text>
      </TouchableOpacity>

      <MasterFilterSheetModal
        visible={sheetOpen}
        title="Elegir rol"
        options={options}
        selectedId={selectedId}
        onSelect={(id) => id && setSelectedId(id)}
        onClose={() => setSheetOpen(false)}
        showAllOption={false}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    gap: spacing.sm,
  },
  description: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  applyBtn: {
    alignSelf: 'flex-start',
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    borderRadius: 10,
    backgroundColor: ticketColors.gold + '18',
    borderWidth: 1,
    borderColor: ticketColors.gold + '40',
    minHeight: 40,
    justifyContent: 'center',
  },
  applyBtnDisabled: {
    opacity: 0.5,
  },
  applyBtnText: {
    ...typography.body,
    color: ticketColors.gold,
    fontWeight: '700',
    fontSize: 14,
  },
});
